// The marker for items an iPhone could not decode (written by a newer app version, data/README.md): shown wherever
// such a store, activity or file appears, so nobody mistakes a partial read for the whole item. Read-only anyway in
// Phase 1; Phase 2 editors must never build a patch from one.

import { Badge } from '@/ui';

export const NEWER_APP_TITLE = 'Created by a newer version of Ground Team. Some details may be missing here until the console is updated.';

export function NewerAppBadge({ long = false, className }: { long?: boolean; className?: string }) {
  return (
    <Badge tone="warning" size="xs" title={NEWER_APP_TITLE} className={className}>
      {long ? 'Created by a newer app' : 'Newer app'}
    </Badge>
  );
}
